import moment from "moment";
import React from "react";
import { TORB1Record } from "redux/app/orb1/@types";
import ORB1TableRows from "../ORB1TableRows";
import { marpolUtils, marpolSelectors } from "redux/app/marpol";
import { TORB1D11 } from "redux/app/orb1/groups/group-d-new";
import { connect, ConnectedProps } from "react-redux";
import { commonUtils } from "redux/_common";
import { IStore } from "../../../../../redux/store";
import orb1Utils from "../../../../../redux/app/orb1/utils";

type OwnProps = {
	orb1Record: TORB1Record;
	isStrikedOff?: boolean;
};
type ORB1D11PreviewProps = React.PropsWithChildren<OwnProps>;
function ORB1D11Preview(props: ORB1D11PreviewProps & PropsFromRedux) {
	const orb1Record = props.orb1Record as TORB1D11;
	const operationDate = moment(orb1Record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<ORB1TableRows
				record={orb1Record}
				tableRows={[
					[operationDate, "D", "13", renderItem13()],
					[null, null, "14", renderItem14()],
					[null, null, "15.3", renderItem15P3()],
					[null, null, "NOTE", orb1Record.remarks],
				]}
			/>
		);
	}

	function renderItem13(): React.ReactNode {
		const bilgeSourceTank = marpolUtils.getProcessedTank(
			orb1Record.item13And14.bilgeSource,
			orb1Record.processedTanks
		);
		const retainedAtSource = bilgeSourceTank.newQuantity;
		return (
			<>
				{orb1Record.item13And14.quantityDischarged.toFixed(2)} M³ FROM{" "}
				{marpolUtils.getFormattedName(orb1Record.item13And14.bilgeSource)}{" "}
				<br />
				TOTAL CAPACITY {orb1Record.item13And14.bilgeSource.totalCapacity} M³,
				QUANTITY RETAINED {retainedAtSource.toFixed(2)} M³
			</>
		);
	}

	function renderItem14() {
		return (
			<h4 className="font-medium uppercase">
				STARTED {orb1Record.item13And14.startOfDischargeTime.time} / FINISHED{" "}
				{orb1Record.item13And14.endOfDischargeTime.time}
			</h4>
		);
	}

	function renderItem15P3() {
		const bilgeHoldingTank = marpolUtils.getProcessedTank(
			orb1Record.item15P3.selectedTank,
			orb1Record.processedTanks
		);
		const retainedAtHoldingTank = bilgeHoldingTank.newQuantity;
		return (
			<h4 className="font-medium uppercase">
				TRANSFER TO {bilgeHoldingTank.tankName}
				<br />
				TANK CAPACITY{" "}
				{orb1Record.item15P3.selectedTank.totalCapacity.toFixed(2)} M³, QUANTITY
				RETAINED {retainedAtHoldingTank.toFixed(2)} M³
			</h4>
		);
	}

	return renderMain();
}

function mapStateToProps(store: IStore) {
	const marpolStore = marpolSelectors._getStore(store);
	const tanks = marpolSelectors.getTanks(marpolStore);
	const isPrimaryBilgeTankPresent =
		marpolUtils.isPrimaryBilgeTankPresent(tanks);
	return {
		isPrimaryBilgeTankPresent,
	};
}
const reduxConnector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(ORB1D11Preview);
